<div class="container alt-offer">

  <div *ngIf="urlParamsService.isAutomatOrigin" class="offer__automat-data">
    <span class="offer__automat-data__package-name">{{ item.packageName }}</span>
    <span class="offer__automat-data__id">{{ item.id }}</span>
  </div>

  <div class="alt-offer__content">
    <div class="alt-offer__content__top">
        <div *ngIf="logoUrl" class="alt-offer__logo">
          <img [src]="logoUrl" alt="">
        </div>

        <ng-template *ngTemplateOutlet="detailsBtn"></ng-template>

        <ng-template *ngTemplateOutlet="primaryCoverages"></ng-template>

        <div class="alt-offer__price">
          <app-offer-fixed-price [offer]="item"></app-offer-fixed-price>
        </div>
      </div>

      <hr class="alt-offer__content__divider">

      <div class="alt-offer__content__bottom">
        <div class="alt-offer__content__bottom__left">
          <div class="alt-offer__car-valuation">
            <app-offer-car-valuation [offer]="item"
                                     [addValuationColorStyles]="true">
            </app-offer-car-valuation>
          </div>

          <div class="alt-offer__details-coverages">
            <ng-container *ngFor="let detailBox of detailBoxes">
              <app-offer-detail-box class="alt-offer__details-coverages__coverage"
                                    *ngIf="canShowBox(detailBox.options, detailBox.selectedOption, detailBox.enabled)"
                                    [box]="detailBox">
              </app-offer-detail-box>
            </ng-container>
          </div>
        </div>

        <ng-template *ngTemplateOutlet="primaryCoverages"></ng-template>

        <ng-template *ngTemplateOutlet="buyOnlineBtn"></ng-template>
      </div>
    </div>

  <div class="alt-offer__footer">
    <ng-template *ngTemplateOutlet="detailsBtn"></ng-template>

    <div class="alt-offer__compare-btn" [class.alt-offer__compare-btn--disabled]="!checkOfferAvailable && !checked">
      <mat-checkbox #compareCheckbox
                    class="alt-offer__compare-btn--text"
                    [ngClass]="{'alt-offer__compare-btn--checked': checked}"
                    [checked]="checked"
                    [disabled]="!checkOfferAvailable && !checked"
                    (change)="onChangeCheckbox()">
        <span (click)="compareOffers($event)">
          <span [innerHTML]="offersComparisonButtonText | translate | safeHtml"></span>
          <ng-container *ngIf="checked">&nbsp;({{amountOfSelectedOffers}})</ng-container>
        </span>
      </mat-checkbox>
    </div>

    <div class="alt-offer__order-call-btn">
      <button class="btn btn--clear"
              (click)="orderCall()">
        {{ 'OFFER_SECTION.SHARED.orderCall' | translate }}
      </button>
    </div>

    <ng-template *ngTemplateOutlet="buyOnlineBtn"></ng-template>
  </div>
</div>

<ng-template #buyOnlineBtn>
  <div class="alt-offer__buy-online">
    <button class="btn btn--secondary btn--small-padding buy-online"
            (click)="buyNow()">
      {{'OFFER_SECTION.SHARED.buyOnline' | translate}}
      <span>&#62;&#62;</span>
    </button>
  </div>
</ng-template>

<ng-template #detailsBtn>
  <div class="alt-offer__details-btn">
    <button class="btn btn--clear"
            (click)="openOffersPresentation()">
      <span class="alt-offer__details-btn__text--details">{{ 'OFFER_SECTION.BOX.details' | translate }}</span>
      <span class="alt-offer__details-btn__text--offer-details">{{ 'OFFER_SECTION.BOX.offerDetails' | translate }}</span>
      <span class="material-icons">arrow_right</span>
    </button>
  </div>
</ng-template>

<ng-template #primaryCoverages>
  <div class="alt-offer__primary-coverages">
    <ng-container *ngFor="let primaryBox of primaryBoxes">
      <app-offer-primary-box class="alt-offer__primary-coverages__coverage offer-primary-box"
                             *ngIf="canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled)"
                             [box]="primaryBox">
      </app-offer-primary-box>
    </ng-container>
  </div>
</ng-template>
